import React from "react";
import ProductListProvider from "../productListProvider/ProductListProvider";
import LoadingSpinner from "../../atoms/LoadingSpinner";
import BackToTopButton from "../../atoms/BackToTopButton";
import ProductListFilter from "../productFilter/ProductListFilter";
import ListViewMoreButton from "./ListViewMoreButton";
import {isTouchDevice} from "../../../helpers/deviceInformation";
import ErrorBoundary from "../../utils/ErrorBoundary";

export type ProductListProps = {
  shopId: number;
  categoryId: number;
  customerId: number;
  customerGroupId: number;
  currency?: string;
  token: string | null;
  filtersToShow: string[];
  filtersToHide: string[];
  defaultFilter?: string;
};

/**
 * The whole list view component, consisting of
 * - filter buttons
 * - product list
 * - buttons for further actions
 *
 * all nested in corresponding context provider. The `showFilters` state is placed here
 * @param props Default params of type `ProductListProps`
 * @constructor
 */
const ProductList: React.FC<ProductListProps> = (props) => (
  <ErrorBoundary fallback={null} occurrence="ProductList">
    <React.Suspense fallback={<LoadingSpinner />}>
      <ProductListProvider {...props}>
        <div className={`product-filter-list grid mb-11 ${!isTouchDevice() ? "no-touch-device" : ""}`}>
          <ProductListFilter />
          <ListViewMoreButton />
        </div>
        <BackToTopButton />
      </ProductListProvider>
    </React.Suspense>
  </ErrorBoundary>
);

export default ProductList;
